import { appConfig } from '../config';

export function parseUser(idTokenJson) {
  if (!idTokenJson)
    return;

  const permissions = getAmiIdentityTokenProperty(idTokenJson, 'Permissions');
  const dealerSettings = getAmiIdentityTokenProperty(
    idTokenJson,
    'DealerSettings'
  );

  const mapped = {
    userData: {
      id: idTokenJson.sub,
      name: idTokenJson.name,
      email: idTokenJson.email,
      dealerSettings: dealerSettings ? JSON.parse(dealerSettings) : undefined,
      scope: appConfig.application,
      permissions: permissions ? permissions.split('|') : undefined,
    }
  };

  return mapped;
}

function getAmiIdentityTokenProperty(identityJson, name) {
  if (!identityJson) return;

  const key = `http://schemas.ami.com/${name}`;
  return identityJson[key];
}
